import { IHookResult } from "../components/_v2/redux/api/local/api-local-interfaces";
import { IPageSettings } from "../interfaces/IPageSettings";

const isValidHook = (hook: IHookResult, currentDirectory: IPageSettings) => {
    let siteAllowed: boolean = true;
    let libraryAllowed: boolean = true;

    if (Array.isArray(hook?.sites)
        && hook.sites.length > 0
        && currentDirectory?.siteDisplayName
        && !hook.sites.some(site => site?.trim().toUpperCase() === currentDirectory.siteDisplayName.trim().toUpperCase())) {
        siteAllowed = false;
    }

    if (siteAllowed
        && Array.isArray(hook?.libraries)
        && hook.libraries.length > 0
        && (currentDirectory?.DocumentLibrary || currentDirectory?.sharepointList)) {
        const listName: string = (currentDirectory?.DocumentLibrary || currentDirectory?.sharepointList).trim().toUpperCase();
        libraryAllowed = hook.libraries.some(library => library?.trim().toUpperCase() === listName);
    }

    if (siteAllowed && libraryAllowed) {
        if (Array.isArray(hook?.blacklistedSites)
            && hook.blacklistedSites.length > 0
            && currentDirectory?.siteDisplayName
            && hook.blacklistedSites.some(site => site?.trim().toUpperCase() === currentDirectory.siteDisplayName.trim().toUpperCase())) {
            siteAllowed = false;
        }

        if (siteAllowed
            && Array.isArray(hook?.blacklistedLibraries)
            && hook.blacklistedLibraries.length > 0
            && (currentDirectory?.DocumentLibrary || currentDirectory?.sharepointList)) {
            const listName: string = (currentDirectory?.DocumentLibrary || currentDirectory?.sharepointList).trim().toUpperCase();
            libraryAllowed = !hook.blacklistedLibraries.some(library => library?.trim().toUpperCase() === listName);
        }
    }

    return (siteAllowed && libraryAllowed);
}

export const getValidHooks = (hooks: IHookResult[], currentDirectory: IPageSettings) => {
    return hooks?.filter(h => isValidHook(h, currentDirectory)) ?? [];
}